import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/base.less'
import 'animate.css';
import './assets/js/flexible.js'

import App from './App.vue'

Vue.use(ElementUI)

Vue.config.productionTip = false

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    'en': require('./assets/languages/en.json'),
    'pt': require('./assets/languages/pt.json'),
    'id': require('./assets/languages/id.json'),
  }
})

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
